// extracted by mini-css-extract-plugin
export default {"table-wrapper":"styles_table-wrapper__MW6dy","ant-table-placeholder":"styles_ant-table-placeholder__CCYzz","title":"styles_title__ypKrP","tableWrapper":"styles_tableWrapper__v3BoW"};